type EntryLinkAttemptHandlers = {
  entryExists: boolean;
  onOpen: () => void;
  onUnavailable: () => void;
};

/**
 * One visit keeps its deadline and terminal result across effect cleanup/replay.
 * Stop disables callbacks; a new visit must create a new attempt.
 */
export function createEntryLinkAttempt() {
  const deadline = Date.now() + 5_000;
  let status: 'pending' | 'opened' | 'expired' = 'pending';
  let active = false;
  let timeout: ReturnType<typeof setTimeout> | undefined;

  return {
    start({ entryExists, onOpen, onUnavailable }: EntryLinkAttemptHandlers) {
      active = true;
      if (status !== 'pending') {
        return;
      }

      clearTimeout(timeout);
      if (entryExists) {
        status = 'opened';
        onOpen();
        return;
      }

      timeout = setTimeout(
        () => {
          if (!active || status !== 'pending') {
            return;
          }
          status = 'expired';
          onUnavailable();
        },
        Math.max(0, deadline - Date.now())
      );
    },
    stop() {
      active = false;
      clearTimeout(timeout);
    }
  };
}
